import { Store } from "reducers/rootReducer";

export type State = {
  chatsId: number | null;
  assessmentId: number | null;
};

const initialState: State = {
  chatsId: null,
  assessmentId: null,
};

// Actions
const SET_CHATS_ID = "app/messages/SET_CHATS_ID";
const SET_ASSESSMENT_ID = "app/messages/SET_ASSESSMENT_ID";

// Reducer
type Action =
  | {
      type: typeof SET_CHATS_ID;
      payload: number;
    }
  | {
      type: typeof SET_ASSESSMENT_ID;
      payload: number;
    };

export default function reducer(state = initialState, action: Action): State {
  switch (action.type) {
    case SET_CHATS_ID:
      return {
        ...state,
        chatsId: action.payload,
      };
    case SET_ASSESSMENT_ID:
      return {
        ...state,
        assessmentId: action.payload,
      };
    default:
      return state;
  }
}

// Action creators
export const setChatsId = (payload: number) => ({
  type: SET_CHATS_ID,
  payload,
});
export const setAssessmentId = (payload: number) => ({
  type: SET_ASSESSMENT_ID,
  payload,
});

// Selectors
export const selectChatsId = (app: Store) => app.messages.chatsId;
export const selectAssessmentId = (app: Store) => app.messages.assessmentId;
